import TaskMedium from "@/domain/task-medium";
import { PointTuple } from "leaflet";

export default class Task {
  public id: string;
  public text: string;
  public answerType: string;
  public difficulty: number;
  public answers: { text: string; correct: boolean }[];
  public media: TaskMedium[];
  public audio?: TaskMedium;
  public photo?: TaskMedium;
  public video?: TaskMedium;
  public timeLimit?: number;
  public survey: boolean;
  public comments: { hint?: string; instructor?: string };
  public pin: {
    none: boolean;
    original?: string;
    iconUrl: string;
    iconSize?: PointTuple;
    iconAnchor?: PointTuple;
    areaColor?: string;
  };

  constructor(id: string, data: Partial<Task>) {
    this.id = id;
    this.text = data.text || "";
    this.answerType = data.answerType || "none";
    this.difficulty = data.difficulty || 0;
    this.answers = data.answers || [];
    this.media = (data.media || []).map(medium => new TaskMedium(medium));
    this.photo = this.media.find(m => m.type === "image");
    this.video = this.media.find(m => m.type === "vimeo" || m.type === "youtube");
    this.audio = this.media.find(m => m.type === "audio");
    this.timeLimit = data.timeLimit;
    this.survey = data.survey || false;
    this.comments = data.comments || {};
    this.pin = data.pin
      ? {
          ...data.pin,
          iconUrl: (data.pin as any)["1x"] || ""
        }
      : { none: true, iconUrl: "" };
  }
}
